import React, { useEffect } from 'react';
import { WhatsappIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/forms';
import {
  StoreIcon,
  ChatIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/help';
import { ExternalLinkIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import Chat from '../Chat';
import AttentionChannelsContainer from './styles/AttentionChannelsStyled';
import { GoogleTagManager } from '../../../helpers';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';
import ButtonBox from '../helpers/ButtonBox';

const AttentionChannels = () => {
  const {
    'url-sucursales': stores = '',
    'url-whatsapp-soporte': supportWhatsapp,
  } = useGlobalData();
  useEffect(() => {
    GoogleTagManager.pushToDataLayer({
      event: 'pagina-virtual',
      page: '/ayuda/canales-atencion',
      pageName: 'Ayuda - Canales de Atención',
    });
  }, []);

  const textSupportWhatsapp = <p>Escríbenos a nuestro WhatsApp</p>;

  const markOptionsSupportWhatsapp = {
    eventCategory: 'Ayuda',
    eventAction: 'Presionar Botón',
    eventTag: 'Whatsapp Soporte',
  };

  return (
    <>
      <Chat
        title="Chat de ayuda"
        subtitle="Resolvemos tus dudas al instante"
        showButton={false}
        from="Otros Canales de Atención"
      />
      <AttentionChannelsContainer>
        <ButtonBox
          buttonColor="bubbleGum"
          buttonText="Whatsapp soporte"
          startIconButton={<WhatsappIcon />}
          variantButton="contained"
          urlRedirect={supportWhatsapp.url}
          title="¿Quieres comunicarte con un ejecutivo?"
          icon={<ChatIcon />}
          text={textSupportWhatsapp}
          markOptions={markOptionsSupportWhatsapp}
        />

        <ButtonBox
          buttonColor="corporate"
          buttonText="VER SUCURSALES"
          endIconButton={<ExternalLinkIcon />}
          variantButton="outlined"
          urlRedirect={stores.url}
          title="Sucursales"
          icon={<StoreIcon />}
          text={
            <p>Revisa también nuestras tiendas disponibles para atención</p>
          }
        />
      </AttentionChannelsContainer>
    </>
  );
};

export default AttentionChannels;
